/**
 * Toast markup
 * Create an Element that holds a toast
 * @param {string} type Valid options such as success, warning, etc
 * @param {string} message The message to be display
 * @param {string} [title] The title of the toast
 * @returns {Node}
 */
function createToastElement(type, message, title, close) {
    const template = `<div class="toast is-${type} ${close ? 'has-close' : ''}">
                        ${title ? `<h2 class="toast-title stack-m">${title}</h2>` : ''}
                        ${close ? `<button class="btn btn-link toast-close">
                            <svg class="icon icon-20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M10 11.414l4.293 4.293a1 1 0 0 0 1.414-1.414L11.414 10l4.293-4.293a1 1 0 1 0-1.414-1.414L10 8.586 5.707 4.293a1 1 0 0 0-1.414 1.414L8.586 10l-4.293 4.293a1 1 0 0 0 1.414 1.414L10 11.414z"/>
                            </svg>
                        </button>` : ''}
                        <span class="toast-message" data-cy="Toast Message">${message}</span>
                      </div>`;
    const wrapper = document.createElement('DIV');
    // TODO how about replace innerHTML to the innerText
    //  or render with vue (escape chars, support router-link, etc)?
    wrapper.innerHTML = template;
    return wrapper.firstChild;
}

/**
 * Class represent a single toast message
 */
export default class Toast {
    static DefaultHideDelay = 5000;

    // Milliseconds
    element = null;

    closeElement = null;

    timerHandle = null;

    hideDelay = null;

    eventListener = null;

    /**
     * Create a new toast message
     * @param {string} type Valid options such as success, warning, etc
     * @param {string} message The message to be display
     * @param {string} [title] The title of the toast
     * @param {boolean} [close] Close icon on the toast
     * @param eventListener
     */
    constructor(type, message, title, close, eventListener) {
        this.element = createToastElement(type, message, title, close);
        this.closeElement = this.element.querySelector('.toast-close');
        this.eventListener = eventListener;
    }

    /**
     * Schedule the toast close itself
     * @param {number} delay Total milliseconds the toast will appear on screen before it closes
     */
    setupAutoHide(delay = Toast.DefaultHideDelay) {
        this.hideDelay = delay;
        this.timerHandle = setTimeout(() => this.hide(), delay);
    }

    /**
     * Prevent the toast to close itself
     */
    disableAutoHide() {
        if (!this.timerHandle) {
            return;
        }
        clearTimeout(this.timerHandle);
        this.timerHandle = null;
    }

    /**
     * Setup the toast UI events
     * 1. No close when the cursor / finger is over it
     * 2. Close when the X is clicked.
     */
    bindUIEvents() {
        this.element.addEventListener('mouseenter', () => this.disableAutoHide());
        this.element.addEventListener('mouseleave', () => this.setupAutoHide(this.hideDelay));
        if (this.closeElement) {
            this.closeElement.addEventListener('click', () => this.hide(true));
        }
    }

    show() {
        this.element.classList.add('is-visible');
    }

    hide(immediate = false) {
        this.disableAutoHide();
        this.element.classList.remove('is-visible');
        this.eventListener.onToastHide(this, immediate);
    }
}
